import { Button, Typography } from '@mui/material';
import React, { Component } from 'react'
import { AppProperties, Logout } from '../../common/functions';
import { useHistory } from "react-router-dom";


const SFLogoutPage = () => {

    let history = useHistory();

    const handleLogout = () => {
        Logout();
        window.location.reload();
    }

    const resumeAssignment = () => {
        window.location.href = window.localStorage.getItem("anonymous_assignment_url")
    }

    return (
        <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center'>
            <Typography fontSize={16} className='text-center'>
                You are currently logged into an anonymous assignment.
            </Typography>
            <Typography fontSize={16} className='text-center mt-2'>
                If you leave this page, you will not be able to resume the assignment (you will need to start the assignment over).
            </Typography>

            <div style={{ display: 'flex', gap: '12px' }}>
                <Button className='mt-3' variant='contained' onClick={resumeAssignment}>Resume Assignment</Button>
                <Button className='mt-3' variant='contained' onClick={handleLogout}>Leave Assignment</Button>
            </div>
        </div>
    );
}

export default SFLogoutPage;